import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import Button from "../ui/Button";
import importImage from './ImportImage';

const Wrapper = styled.div`
 cursor: pointer;
  display: grid;
  margin: 4%;
  margin-bottom: 0%;
  border: thin solid #d4d4d4ff;
  background-color: white;
  border-radius: 18px;
  max-width: 900px;
  padding: 2vw;
  grid-template-areas: 
    "title image"
    "description image"
    "subtitle image";
  grid-template-columns: 1fr 1fr;
  column-gap: 2vw;
 

  @media (max-width: 768px) {
    grid-template-areas:
      "image"
      "title"
      "description"
      "subtitle";
    grid-template-columns: 1fr;
    padding: 5vw;
    
  }
`;

const Container = styled.div`
  grid-area: title;
`;

const Title = styled.h1`
  margin: 0;
  font-size: clamp(1.2rem, 2.5vw, 2rem);
  line-height: 1.3;
  word-break: break-word;
  max-width: 100%;
`;

const Description = styled.p`
  grid-area: description;
  font-size: clamp(1rem, 2vw, 1.25rem);
  line-height: 1.5;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  max-width: 100%;
  margin: 0;
`;

const SubTitle = styled.div`
  grid-area: subtitle;
  color: #888;
  font-weight: bold;
  font-size: clamp(0.9rem, 1.8vw, 1.1rem);
  margin: 0;
`;

const ProjectImage = styled.img`
  grid-area: image;
  width: 100%;
  max-width: 380px;
  height: 260px;  
  object-fit: cover;  
  border-radius: 18px;
  align-self: center;
  justify-self: end; 
 
  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 20px;
    height: 220px;  
  }
`;
 

function PostListItem(props) {
  const { post, onClick } = props;
  const [imageSrc, setImageSrc] = useState('');
  const [inView, setInView] = useState(false);
  const Ref = useRef(null);

  useEffect(() => {
    const loadImages = async () => {
      await importImage(post.images[0], setImageSrc);
    };

    loadImages();
  })

  return (
    <Wrapper ref={Ref}  onClick={() => onClick(post)}>
      <Container> 
        <Title>{post.title}</Title>
      </Container>
      <Description>{post.content}</Description>
      <SubTitle>{post.subtitle}</SubTitle>
      <ProjectImage src={imageSrc} alt={post.images[0]} />
       
    </Wrapper>
  );
}

export default PostListItem;

